<template>
  <div class="szycarousel">
    <el-carousel :class="{ isMobile: isMobile }" :interval="7000">
      <el-carousel-item v-for="(item, index) in silderList" :key="index" >
        <img :src="baseUrl + item.thumb" alt="" @click="showBusiness(item)"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import Config from "@/core/config";

export default {
  name: "SzyCarousel",
  data() {
    return {
      silderList: [],
      baseUrl: Config.baseUrl,
      isMobile: false,
    };
  },
  created() {
    setTimeout(() => {
      this.silderList = JSON.parse(
        localStorage.getItem("homepageData")
      ).silderList;
    }, 0);
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    showBusiness(item){
        this.$emit("changeBusiness", item.id);
    }
  },
  watch: {},
  computed: {},
};
</script>
<style lang="less" scoped>
.szycarousel {
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  .el-carousel {
    height: 500px;
    :deep(.el-carousel__container) {
      height: 500px !important;
    }
  }
  .isMobile {
    height: 120px;
    :deep(.el-carousel__container) {
      height: 120px !important;
      .el-carousel__item {
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
